import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext.js';
import { AppLayout } from './layouts/AppLayout.js';
import { CreatePlanPage } from './pages/CreatePlanPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { PlanDetailPage } from './pages/PlanDetailPage.js';
import { PlansListPage } from './pages/PlansListPage.js';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<AppLayout />}>
            <Route path="/" element={<PlansListPage />} />
            <Route path="/plans/new" element={<CreatePlanPage />} />
            <Route path="/plans/:uuid" element={<PlanDetailPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
